import { DocReference } from '@dadohr/shared/domainTypes/document';
import ENV from '../../../env.json';

const getConsoleUrl = () => {
  return `https://console.firebase.google.com/project/${ENV.firebase.projectId}`;
};

export const toFirestoreConsole = (collection: string, id?: string) => {
  const path = ['data', collection];
  if (id) {
    path.push(id);
  }

  return `${getConsoleUrl()}/database/firestore/${path.join('~2F')}`;
};

export const toFirestoreConsoleFromDoc = (doc: DocReference) => {
  const path = [doc.collection, doc.id];
  return `${getConsoleUrl()}/firestore/data/${path.join('~2F')}`;
};
